import { useEffect, useState } from "react";
import DonationListPc from "./donation_list_pc";
import DonationListMobile from "./donation_list_mobile";
import { donationList, subscriptionCancel } from "../../../api/payment";
import { useNavigate } from "react-router-dom";
import { SessionStorageUtil } from "../../../utils/sessionStorageUtil";

function DonationList() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const pageSize = 10;

  const fetchList = async (page = 1) => {
    if (isFetching) return;
    setIsFetching(true);

    try {
      const res = await donationList(page, pageSize);

      if (Object.keys(res).length === 0) {
        SessionStorageUtil.clearAll();
        navigate("/donation_step1", { replace: true });
      }

      if (res.success === true) {
        const newData = res.data.donations;

        setTotalCount(res.data.pagination.total_count);
        setCurrentPage(page);

        if (isMobile) {
          if (page === 1) {
            setData(newData);
          } else {
            setData((prev) => [...prev, ...newData]);
          }
        } else {
          setData(newData);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchList(1);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageChange = (page) => {
    fetchList(page);
  };

  const cancel = async (billing_subscription_id) => {
    const res = await subscriptionCancel(
      billing_subscription_id,
      "정기후원 취소"
    );
    if (res.success === true) {
      alert(res.message);
    }
  };

  const renderStatus = (status, billingId) => {
    let className = "resend";

    if (status === "canceled") className = "cancel";
    if (status === "suspended") className = "cancel";
    return (
      <button
        className={className}
        onClick={() => {
          if (status === "active") {
            cancel(billingId);
          }
        }}
      >
        해지
      </button>
    );
  };

  const commonProps = {
    data,
    totalCount,
    currentPage,
    pageSize,
    onPageChange: handlePageChange,
    cancel,
    renderStatus,
  };

  return isMobile ? (
    <DonationListMobile {...commonProps} />
  ) : (
    <DonationListPc {...commonProps} />
  );
}

export default DonationList;
